<template>
	<div class="List-home margin-t60">
			<ul>
					<li v-for="(item,index) in dataList" :key='item.ID' @mouseenter="hoverRoll(item)" class=" fadeInUp" :data-wow-delay="index/5+'s'">
							<router-link  :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"  >
									<div class="textBox">
										<p class="title txt-cut1">{{item.Title}}</p>
										<p class="text txt-cut2">{{item.Describe}}</p>
									</div>
										<div class="time"><span> </span> <em>{{setTimeformat(item.ShowTime,'yyyy.mm.dd') }}</em><span></span></div>
							</router-link>
					</li>
				</ul>
	</div>
</template>

<script>
	export default{
		name:'szjs',
		props:{
			szjsList:{
				type:Array,
				default:()=>[]
			},
      dataList: { // 图片列表
      type: Array,
      default: () => []
     },
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>

<style lang="less" scoped>
 @li-width:6.9rem;
  @li-height: 1rem;
  @li-padding: 0.15rem 0;
.List-home{width:6.9rem; min-height: 4rem; margin: 0 auto; font-size: 0; }
 .List-home ul{  padding-top: 0px;width: 6.9rem; padding-top: 0.18rem ; position: relative; display: block;font-size: 0;  margin-bottom: 0rem; }
 .List-home ul>li{ width:  @li-width; 
 position: relative; 
  height: auto; 
  padding:@li-padding;
   background: #eee;
   transition: all 0.3s;
  //  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08); 
   display: inline-block;
   vertical-align: top; 
   margin-bottom: 0.35rem;
   padding-top: 0.2rem; 
   font-size: 0; }
 .List-home ul>li>a>.time{display: block; transition: all 0.3s ;font-size: 12px; padding-top: 0.15rem ;  text-align: center;  line-height: 0.26rem;  color: #666;   }
 .List-home ul>li>a>.time>em{ font-size: 0.22rem; display: inline-block; font-style: normal; margin: 0 0.2rem;vertical-align: middle;  }
 .List-home ul>li>a>.time>span{
   display: inline-block;
   width: 2.4rem;
   height: 0.02rem;
   background: #C4C4C4;
   vertical-align: middle;
 }
 .List-home ul>li:hover{ box-shadow: 0px 0px 0.15rem 0px rgba(0, 0, 0, 0.08); }
  // .List-home ul>li:hover>a>.time{ transform: translateY(-5px);}
 .List-home ul>li .textBox{  padding: 0 20px;}
 .List-home ul>li .textBox .title{  font-size: 0.28rem; color: #333; line-height: 1; padding-top:0.1rem; text-align: justify;}
 .List-home ul>li .textBox .text{  font-size: 0.26rem; color: #666;line-height: 1.5;padding-top:0.1rem; text-align: justify;}
 .List-home ul>li:hover .textBox .title{color: #0376be;}
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue